import * as Factory from 'factory.ts'
import faker from 'faker'

import type { Components } from '@webapp/api/integrations/client'
import { IntegrationCodatConfigStatuses } from '@webapp/models/enums/IntegrationCodatConfigStatus'
import {
  type IntegrationCodatConfig,
  IntegrationServicePlatforms,
} from '@webapp/models/enums/IntegrationPlatforms'
import { IntegrationStatuses } from '@webapp/models/enums/IntegrationStatus'

export const CodatConfigStub = Factory.Sync.makeFactory<IntegrationCodatConfig>(
  {
    link_url: Factory.each(() => faker.internet.url()),
    company_id: Factory.each(() => faker.random.uuid()),
    connection_id: Factory.each(() => faker.random.uuid()),
    platform: Factory.each(() => faker.random.alphaNumeric(4)),
    status: IntegrationCodatConfigStatuses.PENDING_AUTH,
  }
)

export const NetsuiteConfigStub =
  Factory.Sync.makeFactory<Components.Schemas.NetSuiteConfig>({
    account_id: Factory.each(() => faker.random.alphaNumeric(13)),
    client_id: Factory.each(() => faker.random.alphaNumeric(64)),
    client_secret: Factory.each(() => faker.random.alphaNumeric(64)),
    token_id: Factory.each(() => faker.random.alphaNumeric(64)),
    token_secret: Factory.each(() => faker.random.alphaNumeric(64)),
  })

// TODO: update fields to match Sage Intacct configurations
export const SageIntacctConfigStub =
  Factory.Sync.makeFactory<Components.Schemas.NetSuiteConfig>({
    account_id: Factory.each(() => faker.random.alphaNumeric(13)),
    client_id: Factory.each(() => faker.random.alphaNumeric(64)),
    client_secret: Factory.each(() => faker.random.alphaNumeric(64)),
    token_id: Factory.each(() => faker.random.alphaNumeric(64)),
    token_secret: Factory.each(() => faker.random.alphaNumeric(64)),
  })

export const IntegrationResponseStub =
  Factory.Sync.makeFactory<Components.Schemas.IntegrationResponse>({
    id: Factory.each(() => faker.random.uuid()),
    name: IntegrationServicePlatforms.QUICKBOOKS_ONLINE_SANDBOX,
    tenant: Factory.each(() => faker.random.alphaNumeric(8)),
    domain: Factory.each(() => faker.random.alphaNumeric(8)),
    config: Factory.each(() => CodatConfigStub.build()),
    status: IntegrationStatuses.ACTIVE,
    entity_sync_configurations: [],
  })

export const IntegrationResponseNetsuiteStub =
  Factory.Sync.makeFactory<Components.Schemas.IntegrationResponse>({
    id: Factory.each(() => faker.random.uuid()),
    name: IntegrationServicePlatforms.NETSUITE,
    tenant: Factory.each(() => faker.random.alphaNumeric(8)),
    domain: Factory.each(() => faker.random.alphaNumeric(8)),
    config: Factory.each(() => NetsuiteConfigStub.build()),
    status: IntegrationStatuses.ACTIVE,
    entity_sync_configurations: [],
  })

export const IntegrationResponseNetsuiteCodatStub =
  Factory.Sync.makeFactory<Components.Schemas.IntegrationResponse>({
    id: Factory.each(() => faker.random.uuid()),
    name: IntegrationServicePlatforms.CODAT_NETSUITE,
    tenant: Factory.each(() => faker.random.alphaNumeric(8)),
    domain: Factory.each(() => faker.random.alphaNumeric(8)),
    config: Factory.each(() => CodatConfigStub.build()),
    status: IntegrationStatuses.ACTIVE,
    entity_sync_configurations: [],
  })

export const IntegrationResponseSageStub =
  Factory.Sync.makeFactory<Components.Schemas.IntegrationResponse>({
    id: Factory.each(() => faker.random.uuid()),
    name: IntegrationServicePlatforms.SAGE_INTACCT,
    tenant: Factory.each(() => faker.random.alphaNumeric(8)),
    domain: Factory.each(() => faker.random.alphaNumeric(8)),
    config: Factory.each(() => SageIntacctConfigStub.build()),
    status: IntegrationStatuses.ACTIVE,
    entity_sync_configurations: [],
  })
export const MergeConfigStub =
  Factory.Sync.makeFactory<Components.Schemas.MergeConfig>({
    end_user_email_address: Factory.each(() => faker.internet.email()),
    end_user_organization_name: Factory.each(() => faker.company.companyName()),
    end_user_origin_id: Factory.each(() => faker.random.uuid()),
    id: Factory.each(() => faker.random.uuid()),
    integration_slug: 'quickbooks-online',
    status: 'INCOMPLETE',
  })

export const IntegrationResponseMergeStub =
  Factory.Sync.makeFactory<Components.Schemas.IntegrationResponse>({
    id: Factory.each(() => faker.random.uuid()),
    name: IntegrationServicePlatforms.MERGE_QUICKBOOKS_ONLINE,
    tenant: Factory.each(() => faker.random.alphaNumeric(8)),
    domain: Factory.each(() => faker.random.alphaNumeric(8)),
    config: Factory.each(() => MergeConfigStub.build()),
    status: IntegrationStatuses.DISABLED,
    entity_sync_configurations: [],
  })
